import { Organization } from 'torqcloud-ui'

export function canAccessOrganizationSettings(organization?: Pick<Organization, 'permissions'> | null) {
  if (!organization) {
    return false
  }

  return organization.permissions?.manage_organization === true
}

export function canManageOrganizationMembership(organization?: Pick<Organization, 'permissions'> | null) {
  if (!organization) {
    return false
  }

  return organization.permissions?.manage_organization_membership === true
}
